import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c291298"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spinner-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "impala" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "operates" }
const _hoisted_6 = {
  key: 1,
  class: "drag-mask"
}

import { nextTick, onMounted, onUnmounted, provide, ref, watch, watchEffect } from 'vue'
import { throttle } from 'lodash'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore, useKeyboardStore } from '@/store'
import { ContextmenuItem } from '@/components/Contextmenu/types'
import { PPTElement } from '@/types/slides'
import { AlignmentLineProps } from '@/types/edit'
import { injectKeySlideScale } from '@/types/injectKey'
import { removeAllRanges } from '@/utils/selection'
import { KEYS } from '@/configs/hotkey'
import { InfoCircleOutlined } from '@ant-design/icons-vue'

import useViewportSize from './hooks/useViewportSize'
import useMouseSelection from './hooks/useMouseSelection'
import useDropImageOrText from './hooks/useDropImageOrText'
import useRotateElement from './hooks/useRotateElement'
import useScaleElement from './hooks/useScaleElement'
import useSelectElement from './hooks/useSelectElement'
import useDragElement from './hooks/useDragElement'
import useDragLineElement from './hooks/useDragLineElement'
import useMoveShapeKeypoint from './hooks/useMoveShapeKeypoint'
import useInsertFromCreateSelection from './hooks/useInsertFromCreateSelection'

import useDeleteElement from '@/hooks/useDeleteElement'
import useCopyAndPasteElement from '@/hooks/useCopyAndPasteElement'
import useSelectAllElement from '@/hooks/useSelectAllElement'
import useScaleCanvas from '@/hooks/useScaleCanvas'
import useScreening from '@/hooks/useScreening'
import useSlideHandler from '@/hooks/useSlideHandler'

import EditableElement from './EditableElement.vue'
import MouseSelection from './MouseSelection.vue'
import ViewportBackground from './ViewportBackground.vue'
import AlignmentLine from './AlignmentLine.vue'
import Ruler from './Ruler.vue'
import ElementCreateSelection from './ElementCreateSelection.vue'
import MultiSelectOperate from './Operate/MultiSelectOperate.vue'
import enText from "@/lang/en";
import Operate from './Operate/index.vue'
import LinkDialog from './LinkDialog.vue'
import { Modal, Popover } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
import { event } from 'vue-gtag'
import Cookies from 'js-cookie'
import { getPromotionCode } from '@/api/combo'
import { sendClickData } from "@/utils/common";

// const canChat = ref(false)


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  userSelectPreCatalogueId: {
    type: Number,
    default: 0
  },
  paid: {
    type: Number,
    default: -1
  },
  canChat: {
    type: Boolean,
    default: false
  },
  isVip: {
    type: Boolean,
    default: false
  },
  isEnd: {
    type: Boolean,
    default: false
  }
},
  emits: ['changeToolShow'],
  setup(__props, { emit }) {

const props = __props;

const { t, locale, messages }: any = useI18n()
const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { slides, slideIndex } = storeToRefs(slidesStore)
const {
  activeElementIdList,
  activeGroupElementId,
  handleElementId,
  hiddenElementIdList,
  editorAreaFocus,
  gridLineSize,
  showRuler,
  showSelectPanel,
  creatingElement,
  canvasScale,
  textFormatPainter,
  isPc,
  isTourist
} = storeToRefs(mainStore)
const { currentSlide } = storeToRefs(useSlidesStore())
const { ctrlKeyState, spaceKeyState } = storeToRefs(useKeyboardStore())

const viewportRef = ref<HTMLElement>()
const alignmentLines = ref<AlignmentLineProps[]>([])
const promotionCode = ref('')

const linkDialogVisible = ref(false)
const openLinkDialog = () => linkDialogVisible.value = true
const bgImage = require('../../../assets/img/bg1.png')

watch(handleElementId, () => {
  mainStore.setActiveGroupElementId('')
})



const elementList = ref<PPTElement[]>([])
const setLocalElementList = () => {
  elementList.value = currentSlide.value ? JSON.parse(JSON.stringify(currentSlide.value.elements)) : []
}
watchEffect(setLocalElementList)

const canvasRef = ref<HTMLElement>()
const { dragViewport, viewportStyles } = useViewportSize(canvasRef)

useDropImageOrText(canvasRef)

const { mouseSelection, mouseSelectionVisible, mouseSelectionQuadrant, updateMouseSelection } = useMouseSelection(elementList, viewportRef)

const { dragElement } = useDragElement(elementList, alignmentLines, canvasScale)
const { dragLineElement } = useDragLineElement(elementList)
const { selectElement } = useSelectElement(elementList, dragElement)
const { scaleElement, scaleMultiElement } = useScaleElement(elementList, alignmentLines, canvasScale)
const { rotateElement } = useRotateElement(elementList, viewportRef)
const { moveShapeKeypoint } = useMoveShapeKeypoint(elementList, canvasScale)

const { selectAllElement } = useSelectAllElement()
const { deleteAllElements } = useDeleteElement()
const { pasteElement } = useCopyAndPasteElement()
const { enterScreeningFromStart } = useScreening()
const { updateSlideIndex } = useSlideHandler()

const tipsIndex = ref(0);
const onceTime = ref(0);
const opacity = ref(0.5);
const transformTips = ref(100);
const times = ref(0);
const moveText: any = ref(null)
const textArr: any = ref([])
const showText: any = ref('')
const fontSizeScale = ref(100)
const needOpen = ref(true)
// 组件渲染时，如果存在元素焦点，需要清除
// 这种情况存在于：有焦点元素的情况下进入了放映模式，再退出时，需要清除原先的焦点（因为可能已经切换了页面）

watch(viewportStyles, (oldVal, newVal) => {
  let nowScale = (viewportStyles.value.height * canvasScale.value - (160 * canvasScale.value))
  if (nowScale < 240) {
    fontSizeScale.value = 60
  } else if (nowScale < 180) {
    fontSizeScale.value = 40
  } else {
    fontSizeScale.value = 80
  }
})


onMounted(() => {
  // textArr.value = enText.promptsText.Content
  // textArr.value = messages.value[locale.value].promptsText.Content || enText.promptsText.Content
  // showText.value = textArr.value[Math.floor(Math.random() * textArr.value.length)]
  if (activeElementIdList.value.length) {
    nextTick(() => mainStore.setActiveElementIdList([]))
  }
})
function scrollText() {
  needOpen.value = false
  let setTimer = 20
  try {
    if (moveText.value) {
      moveText.value.style.transition = '0.3s ease-in-out'
    }
    if (times.value <= 50) {
      // setTimer = 20
      opacity.value = opacity.value + 0.01;
    } else if (times.value <= 100) {
      setTimer = 50
      opacity.value = opacity.value - 0.01;
    } else if (times.value > 100) {
      // tipsIndex.value++
      // showText.value = textArr.value[tipsIndex.value % textArr.value.length]
      showText.value = textArr.value[Math.floor(Math.random() * textArr.value.length)]
      moveText.value.style.transition = "none"
      times.value = 0;
      onceTime.value = 0
      transformTips.value = 100
      opacity.value = 0.5;
    }
    // if (Math.floor(opacity.value * 10) == 10 && !onceTime.value) {
    if (Math.floor(opacity.value) == 1 && !onceTime.value) {
      onceTime.value++
      setTimer = 3000
    }
    transformTips.value = 100 - 2 * times.value;
    times.value++;
  } catch (error) {

  }

  // if (props.isEnd) {
  //   needOpen.value = true
  //   transformTips.value = 0
  //   return
  // }
  setTimeout(() => {
    scrollText()
  }, setTimer);
}

// 点击画布的空白区域：清空焦点元素、设置画布焦点、清除文字选区、清空格式刷状态
const handleClickBlankArea = (e: any) => {
  // const handleClickBlankArea = (e: MouseEvent) => {
  if (e.target) {
    //点击背景的时候去编辑背景
    emit('changeToolShow', e.target.className == 'viewport-background', 1)
  }
  if (activeElementIdList.value.length) mainStore.setActiveElementIdList([])

  if (!spaceKeyState.value) updateMouseSelection(e)
  else dragViewport(e)

  if (!editorAreaFocus.value) mainStore.setEditorareaFocus(true)
  if (textFormatPainter.value) mainStore.setTextFormatPainter(null)
  removeAllRanges()
}

// 画布注销时清空格式刷状态
onUnmounted(() => {
  if (textFormatPainter.value) mainStore.setTextFormatPainter(null)
})

// 移除画布编辑区域焦点
const removeEditorAreaFocus = () => {
  if (editorAreaFocus.value) mainStore.setEditorareaFocus(false)
}

// 滚动鼠标
const { scaleCanvas } = useScaleCanvas()
const throttleScaleCanvas = throttle(scaleCanvas, 100, { leading: true, trailing: false })
const throttleUpdateSlideIndex = throttle(updateSlideIndex, 300, { leading: true, trailing: false })

const handleMousewheelCanvas = (e: WheelEvent) => {
  e.preventDefault()

  // 按住Ctrl键时：缩放画布
  if (ctrlKeyState.value) {
    if (e.deltaY > 0) throttleScaleCanvas('-')
    else if (e.deltaY < 0) throttleScaleCanvas('+')
  }
  // 上下翻页
  else {
    if (e.deltaY > 0) throttleUpdateSlideIndex(KEYS.DOWN)
    else if (e.deltaY < 0) throttleUpdateSlideIndex(KEYS.UP)
  }
}

// 开关标尺
const toggleRuler = () => {
  mainStore.setRulerState(!showRuler.value)
}

// 在鼠标绘制的范围插入元素
const { insertElementFromCreateSelection } = useInsertFromCreateSelection(viewportRef)

const contextmenus = (): ContextmenuItem[] => {
  return [
    {
      text: t(`editor.ctrlV`), // '粘贴',
      subText: 'Ctrl + V',
      handler: pasteElement,
    },
    {
      text: t(`editor.ctrlA`), // '全选',
      subText: 'Ctrl + A',
      handler: selectAllElement,
    },
    {
      text: t(`editor.canvas.index.ctrlR`), // '标尺',
      subText: showRuler.value ? '√' : '',
      handler: toggleRuler,
    },
    {
      text: t(`editor.canvas.index.ctrlW`), // '网格线',
      handler: () => mainStore.setGridLineSize(gridLineSize.value ? 0 : 50),
      children: [
        {
          text: t(`editor.canvas.index.nl`), // '无',
          subText: gridLineSize.value === 0 ? '√' : '',
          handler: () => mainStore.setGridLineSize(0),
        },
        {
          text: t(`editor.canvas.index.small`), // '小',
          subText: gridLineSize.value === 25 ? '√' : '',
          handler: () => mainStore.setGridLineSize(25),
        },
        {
          text: t(`editor.canvas.index.middle`), // '中',
          subText: gridLineSize.value === 50 ? '√' : '',
          handler: () => mainStore.setGridLineSize(50),
        },
        {
          text: t(`editor.canvas.index.big`), // '大',
          subText: gridLineSize.value === 100 ? '√' : '',
          handler: () => mainStore.setGridLineSize(100),
        },
      ],
    },
    {
      text: showSelectPanel.value ? t(`editor.canvas.index.closePan`) : t(`editor.canvas.index.openPan`), // '关闭选择面板' : '打开选择面板',
      handler: () => {
        if (!showSelectPanel.value) mainStore.setSelectPanelState(true)
        else mainStore.setSelectPanelState(false)
      },
    },
    {
      text: t(`editor.canvas.index.reCurrentPage`), // '重置当前页',
      handler: deleteAllElements,
    },
    { divider: true },
    {
      text: t(`editor.canvas.index.showPpt`), // '幻灯片放映',
      subText: 'F5',
      handler: enterScreeningFromStart,
    },
  ]
}

provide(injectKeySlideScale, canvasScale)


const handleGetTokens = async () => {
  let userList = Cookies.get('e_a_u')
  let uid = Cookies.get('uid')
  if (userList != undefined) {
    if (uid && userList.split(',').indexOf(uid) == -1) {
      // event('13');
    }
  } else {
    // event('13');
  }
  let currentUrl = window.location.href || ''
  // ppt Upgrade to Pro=24
  await sendClickData(24, currentUrl, '', 'canvas')
  window.parent.location.href = "/pricing?d=2"
}
const handleGetCode = () => {
  getPromotionCode().then((res: any) => {
    promotionCode.value = res.data
  }).catch((err: any) => {
  })
}
/* const getTokens = () => {
  getUserCanChatAndDownLoad().then((res: any) => {
    canChat.value = res.data.chat
    canDownLoad.value = res.data.dl
  }).catch ((err: any) => {
  })
}
getTokens() */


return (_ctx: any,_cache: any) => {
  const _directive_contextmenu = _resolveDirective("contextmenu")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "canvas",
    ref_key: "canvasRef",
    ref: canvasRef,
    onWheel: _cache[3] || (_cache[3] = $event => handleMousewheelCanvas($event)),
    onMousedown: _cache[4] || (_cache[4] = $event => handleClickBlankArea($event))
  }, [
    (_unref(creatingElement))
      ? (_openBlock(), _createBlock(ElementCreateSelection, {
          key: 0,
          onCreated: _cache[0] || (_cache[0] = data => _unref(insertElementFromCreateSelection)(data))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "viewport-wrapper",
      style: _normalizeStyle({
      width: _unref(viewportStyles).width * _unref(canvasScale) + 'px',
      height: _unref(viewportStyles).height * _unref(canvasScale) + 'px',
      left: _unref(viewportStyles).left + 'px',
      top: _unref(viewportStyles).top + 'px',
    })
    }, [
      ((!__props.isEnd && _unref(slidesStore).slideIndex > 0 && !_unref(isTourist)))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "top-background-tips",
            style: _normalizeStyle({
        width: _unref(viewportStyles).width * _unref(canvasScale) + 'px',
        height: _unref(viewportStyles).height * _unref(canvasScale) + 'px',
        // 'background-image':isVip||slidesStore.slideIndex>14?'none':'url('+bgImage+')','opacity':isVip||slidesStore.slideIndex>14?'.7':'.97'
      })
          }, [
            _createElementVNode("div", {
              class: "top-half-tips",
              style: _normalizeStyle({
          width: (_unref(viewportStyles).height * _unref(canvasScale)) + 'px',
          height: _unref(viewportStyles).height * _unref(canvasScale) + 'px'
        })
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('editor.canvas.index.generate')), 1),
                _hoisted_2
              ])
            ], 4)
          ], 4))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "top-background-tips",
            style: _normalizeStyle({
        width: _unref(viewportStyles).width * _unref(canvasScale) + 'px',
        height: _unref(viewportStyles).height * _unref(canvasScale) + 'px'
      })
          }, [
            _createElementVNode("div", {
              class: "top-half-tips",
              style: _normalizeStyle({
          width: (_unref(viewportStyles).height * _unref(canvasScale)) + 'px',
          height: _unref(viewportStyles).height * _unref(canvasScale) + 'px'
        })
            }, [
              _createElementVNode("div", {
                class: "top-half-content-tips impalaBox",
                style: _normalizeStyle({
            width: (_unref(viewportStyles).height * _unref(canvasScale) - (160 * _unref(canvasScale))) + 'px',
            height: (_unref(viewportStyles).height * _unref(canvasScale) - (160 * _unref(canvasScale))) + 'px',
          })
              }, _hoisted_4, 4)
            ], 4)
          ], 4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alignmentLines.value, (line, index) => {
          return (_openBlock(), _createBlock(AlignmentLine, {
            key: index,
            type: line.type,
            axis: line.axis,
            length: line.length,
            canvasScale: _unref(canvasScale)
          }, null, 8, ["type", "axis", "length", "canvasScale"]))
        }), 128)),
        (_unref(activeElementIdList).length > 1)
          ? (_openBlock(), _createBlock(MultiSelectOperate, {
              key: 0,
              elementList: elementList.value,
              scaleMultiElement: _unref(scaleMultiElement)
            }, null, 8, ["elementList", "scaleMultiElement"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementList.value, (element) => {
          return _withDirectives((_openBlock(), _createBlock(Operate, {
            key: element.id,
            elementInfo: element,
            isSelected: _unref(activeElementIdList).includes(element.id),
            isActive: _unref(handleElementId) === element.id,
            isActiveGroupElement: _unref(activeGroupElementId) === element.id,
            isMultiSelect: _unref(activeElementIdList).length > 1,
            rotateElement: _unref(rotateElement),
            scaleElement: _unref(scaleElement),
            openLinkDialog: openLinkDialog,
            dragLineElement: _unref(dragLineElement),
            moveShapeKeypoint: _unref(moveShapeKeypoint)
          }, null, 8, ["elementInfo", "isSelected", "isActive", "isActiveGroupElement", "isMultiSelect", "rotateElement", "scaleElement", "dragLineElement", "moveShapeKeypoint"])), [
            [_vShow, !_unref(hiddenElementIdList).includes(element.id) && _unref(isPc) && !_unref(isTourist)]
          ])
        }), 128)),
        _createVNode(ViewportBackground)
      ]),
      _createElementVNode("div", {
        class: "viewport",
        ref_key: "viewportRef",
        ref: viewportRef,
        style: _normalizeStyle({ transform: `scale(${_unref(canvasScale)})` })
      }, [
        (_unref(mouseSelectionVisible))
          ? (_openBlock(), _createBlock(MouseSelection, {
              key: 0,
              top: _unref(mouseSelection).top,
              left: _unref(mouseSelection).left,
              width: _unref(mouseSelection).width,
              height: _unref(mouseSelection).height,
              quadrant: _unref(mouseSelectionQuadrant)
            }, null, 8, ["top", "left", "width", "height", "quadrant"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementList.value, (element, index) => {
          return _withDirectives((_openBlock(), _createBlock(EditableElement, {
            key: element.id,
            elementInfo: element,
            elementIndex: index + 1,
            isMultiSelect: _unref(activeElementIdList).length > 1,
            selectElement: _unref(selectElement),
            openLinkDialog: openLinkDialog
          }, null, 8, ["elementInfo", "elementIndex", "isMultiSelect", "selectElement"])), [
            [_vShow, !_unref(hiddenElementIdList).includes(element.id)]
          ])
        }), 128))
      ], 4)
    ], 4),
    (_unref(spaceKeyState))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
      : _createCommentVNode("", true),
    (_unref(showRuler))
      ? (_openBlock(), _createBlock(Ruler, {
          key: 2,
          viewportStyles: _unref(viewportStyles)
        }, null, 8, ["viewportStyles"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Modal), {
      visible: linkDialogVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((linkDialogVisible).value = $event)),
      footer: null,
      centered: "",
      width: 540,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(LinkDialog, {
          onClose: _cache[1] || (_cache[1] = ($event: any) => (linkDialogVisible.value = false))
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 32)), [
    [_directive_contextmenu, contextmenus],
    [_directive_click_outside, removeEditorAreaFocus]
  ])
}
}

})